
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Settings } from "lucide-react";

const capabilities = [
  { id: 'email-recap', label: 'Email Recaps' },
  { id: 'draft-responses', label: 'Draft Responses' },
  { id: 'day-priority', label: 'Day Prioritization' },
  { id: 'todo-list', label: 'To-Do List Creation' },
  { id: 'calendar-mgmt', label: 'Calendar Management' }
];

export const AIAssistantPreferences = () => {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Settings className="h-5 w-5 text-muted-foreground" />
          <Label className="text-lg font-medium">Assistant Preferences</Label>
        </div>
        
        {/* Capabilities Section */}
        <div className="space-y-2">
          <Label className="text-sm text-muted-foreground">Enabled Capabilities</Label>
          <div className="grid gap-2">
            {capabilities.map(({ id, label }) => (
              <div key={id} className="flex items-center space-x-2">
                <Switch id={id} defaultChecked />
                <Label htmlFor={id}>{label}</Label>
              </div>
            ))}
          </div>
        </div>

        {/* Behavior Section */}
        <div className="space-y-4 mt-6">
          <Label className="text-sm text-muted-foreground">Assistant Behavior</Label>
          <div className="grid gap-2">
            <div className="flex items-center space-x-2">
              <Switch id="proactive" defaultChecked />
              <Label htmlFor="proactive">Proactive Suggestions</Label>
            </div>
            <div className="flex items-center space-x-2">
              <Switch id="auto-reply" />
              <Label htmlFor="auto-reply">Automatic Replies</Label>
            </div>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="voice-tone">Voice & Tone</Label>
            <Select defaultValue="professional">
              <SelectTrigger id="voice-tone" className="w-full">
                <SelectValue placeholder="Select voice & tone" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="professional">Professional</SelectItem>
                <SelectItem value="friendly">Friendly</SelectItem>
                <SelectItem value="concise">Concise</SelectItem>
                <SelectItem value="detailed">Detailed</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
};
